import { useEffect, useState } from "react";

const easeOutCubic = (t: number): number => 1 - Math.pow(1 - t, 3);

export const useCountUp = (target: number, active: boolean, durationMs: number): number => {
    const [value, setValue] = useState(0);

    useEffect(() => {
        if (!active) {
            setValue(0);
            return;
        }
        let frame = 0;
        const startedAt = performance.now();
        const tick = (now: number) => {
            const elapsed = now - startedAt;
            const t = Math.min(elapsed / durationMs, 1);
            setValue(target * easeOutCubic(t));
            if (t < 1) {
                frame = window.requestAnimationFrame(tick);
            }
        };
        frame = window.requestAnimationFrame(tick);
        return () => window.cancelAnimationFrame(frame);
    }, [target, active, durationMs]);

    return value;
};
